export function getQuickMoveIns(state) {
  console.log('store.quick-move-ins.getters.getQuickMoveIns()');
  return _applyFilters(state.quickMoveIns, state.filters);
}

export function getQuickMoveInsAll(state) {
  return state.quickMoveIns;
}

export function getFilter(state) {
  return (field) => state.filters[field];
}

export function getFilters(state) {
  return state.filters;
}

function _applyFilters(quickMoveIns, filters) {
  const keyMap = {
    minPrice: 'price',
    maxPrice: 'price',
    baths: 'baths',
    beds: 'beds',
    neighborhoods: 'communities',
  };

  return quickMoveIns.filter((q) => {
    // loop through each filter
    // if filter has options, loop through communities to only allow those that exist
    let inSet = 0;
    Object.keys(filters).forEach((key) => {
      // console.log('store.quick-move-ins.getters._applyFilters()', key);
      if ( (Array.isArray(filters[key]) && filters[key].length) || (!Array.isArray(filters[key]) && filters[key] !== false) ) {
        // There are options set in this filter, so check if this QuickMoveIn has a match
        switch (key) {
          case 'neighborhoods': {
            // Verbose way of saying "is there a value in this array that is also in that array"
            const hasMatch = filters[key].some((r) => q.communities.findIndex((c) => c.post_title === r) >= 0);
            if (hasMatch) {
              inSet++;
            }
            break;
          }
          case 'minPrice':
            // if set && is price above this value
            if (filters[key] && parseInt(q.price.replace(/,/g, '')) >= filters[key]) {
              inSet++;
            }
            break;
          case 'maxPrice':
            // if set && is price below this value
            if (filters[key] && parseInt(q.price.replace(/,/g, '')) <= filters[key]) {
              inSet++;
            }
            break;
          case 'beds':
          case 'baths':
            // If is set, and number of beds/baths is greater than the option set in the filter
            if (filters[key] !== false && parseInt(q[keyMap[key]]) >= filters[key]) {
              inSet++;
            }
            break;
          default:
            if (filters[key].includes(q[keyMap[key]])) {
              inSet++;
            }
            break;
        }
      } else {
        // no options in this filter, so go ahead and pass
        inSet++;
      }
    });

    return inSet === Object.keys(filters).length;
  });
}
